import { render, staticRenderFns } from "./transfer-received.vue?vue&type=template&id=1f14ec28&"
import script from "./transfer-received.vue?vue&type=script&lang=js&"
export * from "./transfer-received.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports